<template>
  <transition name="fade" mode="out-in">
    <div class="stepper-wrapper">
      <div v-for="positionLevel in TRACKER_CONSTANTS.ORDER_STATUS_BAR_STEPS" :key="positionLevel" :class="`stepper-item ${getStatusBarClass(positionLevel)}`">
        <div class="step-counter"/>
      </div>
    </div>
  </transition>
</template>
<script>
// Mixins
import TemplateMethods from '@/utils/mixins/stepsBarMethods'

const STATUS_BAR_CLASSES = {
  ACTIVE: 'active',
  DISABLED: '',
  COMPLETED: 'completed'
}

export default {
  name: 'Stepper',
  mixins: [TemplateMethods],
  data: () => ({
    STATUS_BAR_CLASSES
  })
}
</script>
